import { InputDatePicker } from '@insurance/components'
import { useValidationsField } from '@insurance/hooks'
import { getEffectiveDateRange } from '@insurance/utils'
import { Form } from 'antd'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

import { useCascoInsuranceValues } from './CascoInsuranceContext'
import { formProps } from './utils'

export const ValidFrom = () => {
  const { t } = useTranslation()
  const { validFromProps, effectiveDateProps } = formProps(t)
  const { required, minDate } = useValidationsField()
  const { isEditable, order } = useCascoInsuranceValues()

  const effectiveDateRange = getEffectiveDateRange(order)

  const newOrderMinDate = dayjs()

  return isEditable ? (
    <Form.Item
      {...effectiveDateProps}
      rules={[required, minDate(effectiveDateRange.minDate)]}
    >
      <InputDatePicker
        minDate={effectiveDateRange.minDate}
        maxDate={effectiveDateRange.maxDate}
        allowClear={false}
      />
    </Form.Item>
  ) : (
    <Form.Item {...validFromProps} rules={[required, minDate(newOrderMinDate)]}>
      <InputDatePicker
        minDate={newOrderMinDate}
        placeholder={validFromProps.label}
      />
    </Form.Item>
  )
}
